var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import convertToTree from 'src/utils/treeOperations/convertToTree';
import highlighter from 'src/utils/highlighter';
import Card from 'src/components/Card/Card';
import Tooltip from 'src/components/Tooltips/Tooltip.vue';
import scrollIntoViewIfItIsNot from 'src/utils/domOperations/scrollIntoViewIfItIsNot';
export default Vue.extend({
    components: { Card, Tooltip },
    props: {
        titleProp: { type: String },
        subtitleProp: { type: String },
        singleSelectProp: { type: Boolean, default: true },
        noTickFuncProp: { type: Function },
        visibleProp: { type: Boolean },
        dataGetterProp: { type: Function },
        tickStrategyProp: { type: String, default: 'strict' },
        submitCallbackProp: { type: Function }
    },
    data() {
        return {
            visible: false,
            needle: '',
            searchFields: ['name', 'id'],
            searchFieldsSelectorVisible: false,
            loading: false,
            dataParam: [],
            handleSelectorValueSelection: () => { return null; },
            showUpstreamBranchesOfFilteredNodes: true,
            expandedKeysData: [],
            tickedKeys: [],
            tickedKeysAtStart: [],
            initializationInProgres: false,
            tickStrategy: 'strict',
            title: 'Select single value at any level'
        };
    },
    computed: {
        cardProps() {
            return {
                hideFooter: this.hideFooter,
                bodyCardSectionStyles: 'max-height:90vh;padding-top:0',
            };
        },
        sortedFieldsOfDataParam() {
            const { searchFields, dataParam } = this;
            if (!Array.isArray(dataParam))
                return [];
            const fieldsOfDataParam = Object.keys(this.dataParam[0] || {}).filter(k => k !== 'children');
            const idAndName = ['id', 'name'];
            const rest = fieldsOfDataParam.filter(f => !idAndName.includes(f) && !searchFields.includes(f)).sort();
            const all = [...idAndName, ...searchFields, ...rest];
            return [...new Set(all)];
        },
        keysThatHaveBeenUntickedSinceStart() {
            if (this.tickedKeysAtStart === null)
                return null;
            return this.tickedKeysAtStart.filter(k1 => !this.tickedKeys.includes(k1));
        },
        keysThatHaveBeenTickedSinceStart() {
            if (this.tickedKeysAtStart === null || this.tickedKeys === null) {
                return this.tickedKeys;
            }
            else {
                return this.tickedKeys.filter(k1 => { var _a; return !((_a = this.tickedKeysAtStart) === null || _a === void 0 ? void 0 : _a.includes(k1)); });
            }
        },
        hideFooter() {
            return !this.submitCallbackProp || ((this.keysThatHaveBeenUntickedSinceStart || []).length === 0 && (this.keysThatHaveBeenTickedSinceStart || []).length === 0);
        },
        expandedKeysComputed: {
            get() {
                if (this.needle !== '')
                    return this.dataParam.map(r => r.id);
                return this.expandedKeysData;
            },
            set(val) { this.expandedKeysData = val; }
        },
        dataPropAlteredByFuncs() {
            if (!Array.isArray(this.dataParam))
                return null;
            const data = [...this.dataParam];
            if (this.noTickFuncProp) {
                const noTickFuncProp = this.noTickFuncProp;
                data.forEach(row => {
                    if (noTickFuncProp(row))
                        row.noTick = true;
                });
            }
            return data;
        },
        normalizedNeedle() {
            return this.normalizeNeedleAndStack(this.needle);
        },
        treeToDisplay() {
            var _a;
            const data = this.dataPropAlteredByFuncs;
            if (!Array.isArray(data))
                return null;
            const maxNodeCount = 500; // this is done to limit rendered nodes in q-tree.  it stalls when node count is too high
            const needle = this.normalizedNeedle;
            if (needle === '') {
                const res = convertToTree(data.slice(0, maxNodeCount));
                return res;
            }
            const needleIsFound = (needle, node) => {
                const searchFields = this.searchFields;
                for (const field of searchFields) {
                    const value = this.normalizeNeedleAndStack(node[field]);
                    if (value.includes(needle))
                        return true;
                }
                if (node.children)
                    return node.children.some((c) => needleIsFound(needle, c));
                return false;
            };
            let res = [];
            if (this.showUpstreamBranchesOfFilteredNodes) {
                let nodeCount = 0;
                let filteredData = [];
                for (const row of data) {
                    if (needleIsFound(needle, row)) {
                        filteredData.push(row);
                        nodeCount++;
                    }
                    if (nodeCount >= maxNodeCount)
                        break;
                }
                const addMissingParents = (nodes) => {
                    let res = [];
                    const ids = nodes.map((n) => n.id);
                    const parentIds = nodes.map((n) => n.parent_id) || [];
                    const missingParents = parentIds.filter((id) => !ids.includes(id));
                    if (missingParents.length > 0) {
                        let missingParentsRows = data.filter(d => missingParents.includes(d.id));
                        addMissingParents(missingParentsRows);
                    }
                    res = [...nodes, ...data.filter(d => missingParents.includes(d.id))];
                    return res;
                };
                filteredData = addMissingParents(filteredData);
                const tree = convertToTree(filteredData);
                const filterChildren = (arr) => {
                    let arr2 = arr.filter(r => needleIsFound(needle, r));
                    arr2.forEach(a => {
                        if (a.children) {
                            a.children = filterChildren(a.children);
                        }
                    });
                    return arr2;
                };
                res = filterChildren(tree);
                return res;
            }
            else {
                res = convertToTree((_a = data.filter(r => JSON.stringify(r).toLowerCase().includes(needle))) === null || _a === void 0 ? void 0 : _a.slice(0, maxNodeCount));
            }
            return res;
        }
    },
    watch: {
        titleProp: {
            immediate: true,
            handler(newVal) { if (newVal)
                this.title = newVal; }
        },
        tickStrategyProp: {
            immediate: true,
            handler(newVal) { if (newVal)
                this.tickStrategy = newVal; }
        },
        dataParam: {
            immediate: true,
            deep: false,
            handler(newVal) {
                this.tickedKeys = (newVal || []).filter((r) => r.ticked).map((r) => r.id);
                this.tickedKeysAtStart = [...this.tickedKeys];
            }
        },
        visibleProp: {
            immediate: true,
            handler(newVal) { this.visible = Boolean(newVal); }
        },
        dataGetterProp: {
            immediate: true,
            handler(dataGetterCallback) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (typeof dataGetterCallback === 'function') {
                        this.loading = true;
                        const response = yield dataGetterCallback();
                        if (response)
                            this.dataParam = response;
                        this.loading = false;
                    }
                });
            }
        },
        tickedKeys(newVal, oldVal) {
            if (this.singleSelectProp && !this.initializationInProgres && newVal.length > 0) {
                const newTickedKey = newVal === null || newVal === void 0 ? void 0 : newVal.find((v) => !oldVal.includes(v));
                if (newTickedKey)
                    this.handleSelectorValueSelection(newTickedKey);
                this.visible = false;
            }
        },
        visible(newVal) {
            if (!newVal)
                this.$emit('unloadComponent');
            if (newVal) {
                Vue.nextTick(() => {
                    const el = this.$refs.needleInput;
                    if (!el)
                        return false;
                    // @ts-ignore
                    el.focus();
                    // @ts-ignore
                    el.select();
                });
            }
        }
    },
    methods: {
        toggleSearchFieldSelectorVisibility() {
            this.searchFieldsSelectorVisible = !this.searchFieldsSelectorVisible;
        },
        toggleItemPresence(item, arr) {
            if (arr.includes(item)) {
                this.searchFields = arr.filter(f => f !== item);
            }
            else {
                this.searchFields = [...arr, item];
            }
        },
        convertToTree(treeNodes) { return convertToTree(treeNodes); },
        highlighter(stack, needle) { return highlighter(stack, needle); },
        normalizeNeedleAndStack(needle) { return String(needle || '').toLowerCase(); },
        submit() {
            const keysThatHaveBeenTickedSinceStart = this.keysThatHaveBeenTickedSinceStart;
            const keysThatHaveBeenUntickedSinceStart = this.keysThatHaveBeenUntickedSinceStart || [];
            if (typeof this.submitCallbackProp === 'function') {
                this.submitCallbackProp({
                    keysThatHaveBeenTickedSinceStart,
                    keysThatHaveBeenUntickedSinceStart
                });
            }
            this.visible = false;
        },
        openDialog(params) {
            this.tickStrategy = params.tickStrategy || this.tickStrategy;
            this.title = params.title || this.title;
            const currentValueParam = params.currentValueParam;
            this.dataParam = params.dataParam || [];
            this.handleSelectorValueSelection = params.handleSelectorValueSelection || this.handleSelectorValueSelection;
            this.initializationInProgres = true;
            this.visible = true;
            this.expandedKeysData = [];
            this.tickedKeys = [];
            this.expandKeyAndItsParents(Number(currentValueParam));
            this.tickedKeys.push(Number(currentValueParam));
            setTimeout(() => {
                scrollIntoViewIfItIsNot('node_id' + currentValueParam, 'topSection', 'bottom', 'mainCard', 'bottom');
            }, 200);
            Vue.nextTick(() => { this.initializationInProgres = false; }); // without setTimeout, watch:tickedKeys runs after initializationInProgres is set to false, leading to logic error
        },
        expandKeyAndItsParents(key) {
            var _a, _b;
            this.expandedKeysData.push(key);
            const currentItem = (_a = this.dataParam) === null || _a === void 0 ? void 0 : _a.find(r => r.id === key);
            if (!currentItem)
                return;
            const parentItem = (_b = this.dataParam) === null || _b === void 0 ? void 0 : _b.find(r => r.id === currentItem.parent_id);
            if (parentItem)
                this.expandKeyAndItsParents(parentItem.id);
        },
        handleClickOnNode(node) {
            this.$emit('nodeClicked', node);
        }
    }
});
